var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBikeblack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9677 10H19.0323C20.6667 10 22 11.8 22 14.0065V26.2C22 27.1871 21.3978 28 20.6667 28H11.3333C10.6022 28 10 27.1871 10 26.2V14.0065C10 11.8 11.3333 10 12.9677 10Z",
    fill: "#ABABAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0008 22.0684C17.5456 22.0684 18.7594 23.2822 18.7594 24.827V29.2408C18.7594 30.7856 17.5456 31.9994 16.0008 31.9994C14.456 31.9994 13.2422 30.7856 13.2422 29.2408V24.827C13.2422 23.2822 14.456 22.0684 16.0008 22.0684Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 18.207C18.4273 18.207 20.4135 20.1932 20.4135 22.6208V24.8277H11.5859V22.6208C11.5859 20.1932 13.5721 18.207 15.9997 18.207Z",
    fill: "#DEDEDE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8965 15.4492H17.1033V16.5527H14.8965V15.4492Z",
    fill: "#212121"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8965 13.2422H17.1033V14.3456H14.8965V13.2422Z",
    fill: "#212121"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8965 5.51758H27.0344V6.62103H22.8965V5.51758Z",
    fill: "#212121"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96484 5.51758H9.0476V6.62103H4.96484V5.51758Z",
    fill: "#212121"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6191 5.35322H21.5156V2.20839C21.5156 1.9877 21.626 1.76701 21.8467 1.71184L24.9363 0.498047L25.3777 1.49115L22.6191 2.5946V5.35322Z",
    fill: "#666666"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8262 0H28.1365V2.2069H24.8262V0Z",
    fill: "#666666"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4827 5.51727H9.37923V2.59313L6.67578 1.48968L7.06199 0.441406L10.0965 1.6552C10.3723 1.76554 10.4827 1.98623 10.4827 2.20692V5.51727Z",
    fill: "#666666"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M3.86133 0H7.17167V2.2069H3.86133V0Z",
    fill: "#666666"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.173 7.17175L17.6557 8.2752H14.3454L8.82812 7.17175V4.96484H23.173V7.17175Z",
    fill: "#DEDEDE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 10.482C17.8281 10.482 19.3101 8.99993 19.3101 7.17167C19.3101 5.34342 17.8281 3.86133 15.9998 3.86133C14.1715 3.86133 12.6895 5.34342 12.6895 7.17167C12.6895 8.99993 14.1715 10.482 15.9998 10.482Z",
    fill: "#212121"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 9.37864C17.2187 9.37864 18.2068 8.39058 18.2068 7.17174C18.2068 5.95291 17.2187 4.96484 15.9999 4.96484C14.781 4.96484 13.793 5.95291 13.793 7.17174C13.793 8.39058 14.781 9.37864 15.9999 9.37864Z",
    fill: "#DEDEDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBikeblack);
export default __webpack_public_path__ + "static/media/bikeblack.bd969b8f0e0f4eae997b73fd04f4f236.svg";
export { ForwardRef as ReactComponent };